import type { TaskHistoryItem } from '../types/taskHistory';

export type TaskHistoryObjectNavTarget =
  | { kind: 'application'; applicationId: number }
  | { kind: 'route'; routeId: number; routeStopId?: number };

/**
 * Навигация по entityType + идентификаторам объекта (не по тексту objectLabel).
 */
export function resolveTaskHistoryObjectNavigation(
  item: Pick<
    TaskHistoryItem,
    'entityType' | 'applicationId' | 'routeId' | 'routeStopId' | 'scope'
  >
): TaskHistoryObjectNavTarget | null {
  if (item.entityType === 'APPLICATION') {
    const applicationId = Number(item.applicationId);
    if (Number.isFinite(applicationId) && applicationId > 0) {
      return { kind: 'application', applicationId };
    }
    return null;
  }

  const routeId = Number(item.routeId);
  if (!Number.isFinite(routeId) || routeId <= 0) {
    return null;
  }

  if (item.scope === 'STOP') {
    const routeStopId = Number(item.routeStopId);
    if (Number.isFinite(routeStopId) && routeStopId > 0) {
      return { kind: 'route', routeId, routeStopId };
    }
  }

  return { kind: 'route', routeId };
}

export function buildTaskHistoryObjectPath(target: TaskHistoryObjectNavTarget): string {
  if (target.kind === 'application') {
    return `/applications/${target.applicationId}?tab=main`;
  }

  const params = new URLSearchParams({ tab: 'card' });
  if (target.routeStopId != null && target.routeStopId > 0) {
    params.set('stopId', String(target.routeStopId));
  }
  return `/routes/${target.routeId}?${params.toString()}`;
}
